<template>
  <div class="no-offers">
    <div class="row">
      <div class="col-sm-8">
        <div>
          <h4>No Offers Found</h4>
          Sorry, but at this time there are no offers available.
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'NotValid',
  props: ['consumerId'],
  computed: {
    ...mapState({
      loadedId: state => state.consumer.consumerId
    }),
    ...mapGetters({
      consumerLoaded: 'consumer/consumerLoaded'
    })
  },
  methods: {
    load (id) {
      if (!this.consumerLoaded || this.loadedId !== id) {
        this.loadConsumer(id)
      }
    },
    ...mapActions({
      loadConsumer: 'consumer/retrieveConsumer'
    })
  },
  mounted () {
    if (this.consumerId) {
      this.load(this.consumerId)
    }
  },
  watch: {
    consumerId (val) {
      this.load(val)
    }
  }
}
</script>
